import { Dropdown } from "bootstrap"

console.log("[navbar_dropdowns] file loaded")
window.__navbarDropdownsLoaded = true

document.addEventListener("click", (event) => {
  const toggle = event.target.closest('.navbar [data-bs-toggle="dropdown"]')

  if (!toggle) return

  console.log("[navbar_dropdowns] dropdown click caught:", toggle.id)

  event.preventDefault()
  event.stopImmediatePropagation()

  const dropdown = Dropdown.getOrCreateInstance(toggle)
  dropdown.toggle()
}, true)